<div class="btn-toolbar">
  @if (visible) {
    <div
      class="btn-group yc-button"
      dropdown>
      <button class="btn btn-link dropdown-toggle"
        type="button"
        dropdownToggle>
        {{ activeNpo?.displayName || activeNpo?.name }}
        @if (activeNpo?.registrationId) {
          <span>
            &nbsp;({{activeNpo?.registrationId}})
          </span>
        }
      </button>
      <ul *dropdownMenu
        class="dropdown-menu"
        role="menu">
        @for (link of links; track link) {
          <li role="menuitem">
            <a
              [routerLinkActive]="'active'"
              [routerLink]="[link.href]"
              class="dropdown-item">
              <yc-i18n
                [key]="link.i18nKey"
                [defaultValue]="link.label"
                [context]="link.href === 'notes' ? notesLinkContext : (link.context || {})">
              </yc-i18n>
            </a>
          </li>
        }
      </ul>
      <button class="btn btn-link copy-reg"
        [tooltip]="tooltipText"
        (click)="copyRegistrationId(activeNpo?.registrationId)">
        <yc-fa class="text-info"
          icon="copy"
          [light]="true">
        </yc-fa>
      </button>
    </div>
  }
</div>